import React from "react"
import { useControl } from "../../../controlContext"
import { ICN, REC, REP_BLOCK, REP_SEC, SUB } from "../../../../../shared/Data/typeDirs"
import { useSource } from "../../../sourceContext"
import { Col, Row } from "react-bootstrap"
import { reportIcons } from "../../../../../shared/Data/reportIcons"
import '../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/exportTableOfContents.css'
export function ExportTableOfContents() {
  const controls = useControl()
  const source = useSource()
  let currentSection
  return (
    <div className="toc-top-container">
      {
        controls.filter(itm => itm.type === REP_BLOCK).map((block) => {
          const sectionRow = currentSection !== block[REP_SEC] ? (
            <Row className="toc-section-row">
              <h1>{source[REP_SEC].find(itm => itm._id === block[REP_SEC]).getDisplayText()}</h1>
            </Row>
          ) : []
          const sub = source[SUB].find(itm => itm._id === block[SUB])
          let [num, ...label] = sub.getDisplayText().slice(4).split(' ')
          label = block.blockName
          currentSection = block[REP_SEC]
          return (
            <div className="toc-container" >
              {sectionRow}
              <Row>
                <Col sm="2" className="toc-icon-col" >
                  <span style={{ float: 'right' }}>
                    {
                      block[REC].reduce((prev, cur, idx) => {
                        if (cur[ICN]) prev = [...prev, ...cur[ICN]]
                        // console.log('accumulating icons', ICN, prev, cur)
                        return prev
                      }, []).map((icn, icnIdx) =>
                        <img key={icnIdx} alt={`${ICN} ${icn}`} className="toc-icon" src={reportIcons.find(repIcn => repIcn._name === icn).single} />
                      )
                    }
                  </span>
                </Col>
                <Col className="toc-content-col">
                  <Row>
                    <Col className="toc-num-col" sm="2" >
                      <span className="toc-num"><a href={`#${block._id}`}>{num}&nbsp;—&nbsp;</a></span>
                    </Col>
                    <Col >
                      <Row>
                        {label}
                      </Row>
                      {block[REC].map(rec => (
                        <Row className="toc-rec-content">
                          {rec.content}
                        </Row>
                      ))}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          )
        })
      }
    </div>
  )
}